export default "__VITE_ASSET__BNtfII8Y__"